import React from 'react';
import { MultiSelect, Text } from '@usealloy/component-library';
import { Controller, useFormContext } from 'react-hook-form';
import type { FormState } from './types';
import { getServiceFailureDefaultOptions } from './helpers';
import {
  StyledTagLocalFormContainer,
  StyledLeftColumnContainer,
} from './styles';
import useNodeFormAutoSave from '../useNodeFormAutoSave';
import type { NodeEditorAutoSaveTabProps } from '../useNodeEditorForm/types';
import { useAppSelector } from '~/store/reduxHooks';
import { selectDiffMode, selectWorkflowFailureHandlingMode } from 'flow/store/redux/selectors';
import { failureHandlingDescriptionBestEffortMode, failureHandlingDescriptionFullThresholdMode } from '../constants';
import { getDiffStyleFunction, PLACEHOLDER_DIFF_STATUS } from '../diffStyles';


export default function TagLocalSettingsTab({
  handleAutoSave: onAutoSave,
  isReadOnly,
}: NodeEditorAutoSaveTabProps) {
  const {
    control,
  } = useFormContext<FormState>();
  const failureHandlingModeValue = useAppSelector(selectWorkflowFailureHandlingMode);
  const isInDiffMode = useAppSelector(selectDiffMode);

  // TODO: hardcoded until the per-field diff status is wired in. The diff-mode guard is
  // redundant once that lookup returns null outside diff mode, and can be dropped then.
  const diffStatus = isInDiffMode ? PLACEHOLDER_DIFF_STATUS : null;

  const serviceFailureOptions = React.useMemo(() => getServiceFailureDefaultOptions(), []);
  useNodeFormAutoSave({ fn: onAutoSave });

  const handlingDescription = failureHandlingModeValue === 'full-threshold'
    ? failureHandlingDescriptionFullThresholdMode : failureHandlingDescriptionBestEffortMode;

  return (
    <StyledTagLocalFormContainer>
      <StyledLeftColumnContainer>
        <Controller
          name="serviceFailureDefaultOption"
          control={control}
          render={({ field: { onChange, value } }) => (
            <>
              <MultiSelect
                isMulti={false}
                label="Service Failure Handling - if data is missing:"
                onChange={onChange}
                options={serviceFailureOptions}
                selectedOptions={value}
                isDisabled={isReadOnly}
                customStyleFunctions={getDiffStyleFunction(diffStatus)}
              />
              <Text as="span" size={2} style={{ color: 'var(--cl-text-secondary)' }}>
                {handlingDescription}
              </Text>
            </>
          )}
        />
      </StyledLeftColumnContainer>
    </StyledTagLocalFormContainer>
  );
}

